var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-card",
    { style: _vm.cardStyle, attrs: { bordered: false } },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c("a-form", { attrs: { form: _vm.form } }, [
            _c(
              "div",
              { staticClass: "tabs-header" },
              [
                _c(
                  "a-tabs",
                  {
                    attrs: { "active-key": _vm.activeKey },
                    on: { change: _vm.handleTabChange },
                  },
                  [
                    _c("a-tab-pane", {
                      key: "sec1",
                      attrs: { tab: "基本资料" },
                    }),
                    _c("a-tab-pane", {
                      key: "sec2",
                      attrs: { tab: "配置信息" },
                    }),
                    _c("a-tab-pane", {
                      key: "sec3",
                      attrs: { tab: "总店性质" },
                    }),
                    _c("a-tab-pane", {
                      key: "sec4",
                      attrs: { tab: "地址定位与地图服务" },
                    }),
                  ],
                  1
                ),
                _c(
                  "a-button",
                  {
                    staticClass: "tabs-save-btn",
                    attrs: { type: "primary", loading: _vm.confirmLoading },
                    on: { click: _vm.handleSaveAll },
                  },
                  [_vm._v("保存")]
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                ref: "container",
                staticClass: "content-container",
                style: _vm.contentStyle,
              },
              [
                _c(
                  "div",
                  {
                    ref: "sec1",
                    staticClass: "section",
                    attrs: { id: "sec1" },
                  },
                  [
                    _c("h2", [_vm._v("基本资料")]),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.baseWrapperCol,
                                  label: "公司名称",
                                },
                              },
                              [
                                _c("a-input", {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator.trim",
                                      value: ["companyName"],
                                      expression: "[ 'companyName' ]",
                                      modifiers: { trim: true },
                                    },
                                  ],
                                  attrs: {
                                    placeholder: "请输入公司名称",
                                    disabled: _vm.hqManaged,
                                  },
                                  on: { change: _vm.handleCompanyName },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.baseWrapperCol,
                                  label: "联系人",
                                },
                              },
                              [
                                _c("a-input", {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator.trim",
                                      value: ["companyContacts"],
                                      expression: "[ 'companyContacts' ]",
                                      modifiers: { trim: true },
                                    },
                                  ],
                                  attrs: {
                                    placeholder: "请输入联系人",
                                    disabled: _vm.hqManaged,
                                  },
                                  on: { change: _vm.handleCompanyContacts },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.baseWrapperCol,
                                  label: "公司电话",
                                },
                              },
                              [
                                _c("a-input", {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator.trim",
                                      value: ["companyTel"],
                                      expression: "[ 'companyTel' ]",
                                      modifiers: { trim: true },
                                    },
                                  ],
                                  attrs: {
                                    placeholder: "请输入公司电话",
                                    disabled: _vm.hqManaged,
                                  },
                                  on: { change: _vm.handleCompanyTel },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.baseWrapperCol,
                                  label: "公司传真",
                                },
                              },
                              [
                                _c("a-input", {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator.trim",
                                      value: ["companyFax"],
                                      expression: "[ 'companyFax' ]",
                                      modifiers: { trim: true },
                                    },
                                  ],
                                  attrs: {
                                    placeholder: "请输入公司传真",
                                    disabled: _vm.hqManaged,
                                  },
                                  on: { change: _vm.handleCompanyFax },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.baseWrapperCol,
                                  label: "公司邮编",
                                },
                              },
                              [
                                _c("a-input", {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator.trim",
                                      value: ["companyPostCode"],
                                      expression: "[ 'companyPostCode' ]",
                                      modifiers: { trim: true },
                                    },
                                  ],
                                  attrs: {
                                    placeholder: "请输入公司邮编",
                                    disabled: _vm.hqManaged,
                                  },
                                  on: { change: _vm.handleCompanyPostCode },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.baseWrapperCol,
                                  label: "销售协议",
                                },
                              },
                              [
                                _c("a-input", {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator.trim",
                                      value: ["saleAgreement"],
                                      expression: "[ 'saleAgreement' ]",
                                      modifiers: { trim: true },
                                    },
                                  ],
                                  attrs: { placeholder: "请输入销售协议" },
                                  on: { change: _vm.handleSaleAgreement },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    ref: "sec2",
                    staticClass: "section",
                    attrs: { id: "sec2" },
                  },
                  [
                    _c("h2", [_vm._v("配置信息")]),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "分配仓库权限",
                                },
                              },
                              [
                                _c("a-switch", {
                                  attrs: {
                                    "checked-children": "启用",
                                    "un-checked-children": "关闭",
                                  },
                                  on: { change: _vm.onDepotChange },
                                  model: {
                                    value: _vm.depotFlagSwitch,
                                    callback: function ($$v) {
                                      _vm.depotFlagSwitch = $$v
                                    },
                                    expression: "depotFlagSwitch",
                                  },
                                }),
                                _vm._v("\n                （启用后，需要到"),
                                _c("b", [_vm._v("用户管理")]),
                                _vm._v("进行"),
                                _c("b", [_vm._v("分配仓库")]),
                                _vm._v(
                                  "，针对专人管理仓库的场景）\n              "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "分配客户权限",
                                },
                              },
                              [
                                _c("a-switch", {
                                  attrs: {
                                    "checked-children": "启用",
                                    "un-checked-children": "关闭",
                                  },
                                  on: { change: _vm.onCustomerChange },
                                  model: {
                                    value: _vm.customerFlagSwitch,
                                    callback: function ($$v) {
                                      _vm.customerFlagSwitch = $$v
                                    },
                                    expression: "customerFlagSwitch",
                                  },
                                }),
                                _vm._v("\n                （启用后，需要到"),
                                _c("b", [_vm._v("用户管理")]),
                                _vm._v("进行"),
                                _c("b", [_vm._v("分配客户")]),
                                _vm._v(
                                  "，针对销售员只能看自己客户的场景）\n              "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "支持负库存",
                                },
                              },
                              [
                                _c("a-switch", {
                                  attrs: {
                                    "checked-children": "启用",
                                    "un-checked-children": "关闭",
                                  },
                                  on: { change: _vm.onMinusStockChange },
                                  model: {
                                    value: _vm.minusStockFlagSwitch,
                                    callback: function ($$v) {
                                      _vm.minusStockFlagSwitch = $$v
                                    },
                                    expression: "minusStockFlagSwitch",
                                  },
                                }),
                                _vm._v("\n                （启用后，单据"),
                                _c("b", [_vm._v("支持负库存")]),
                                _vm._v(
                                  "录入，不会再提示库存不足）\n              "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "以销定购",
                                },
                              },
                              [
                                _c("a-switch", {
                                  attrs: {
                                    "checked-children": "启用",
                                    "un-checked-children": "关闭",
                                  },
                                  on: { change: _vm.onPurchaseBySaleChange },
                                  model: {
                                    value: _vm.purchaseBySaleFlagSwitch,
                                    callback: function ($$v) {
                                      _vm.purchaseBySaleFlagSwitch = $$v
                                    },
                                    expression: "purchaseBySaleFlagSwitch",
                                  },
                                }),
                                _vm._v("\n                （启用后，根据"),
                                _c("b", [_vm._v("销售订单")]),
                                _vm._v("来定制"),
                                _c("b", [_vm._v("采购订单")]),
                                _vm._v("，进货后再发给客户）\n              "),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "超出关联单据",
                                },
                              },
                              [
                                _c("a-switch", {
                                  attrs: {
                                    "checked-children": "启用",
                                    "un-checked-children": "关闭",
                                  },
                                  on: { change: _vm.onOverLinkBillChange },
                                  model: {
                                    value: _vm.overLinkBillFlagSwitch,
                                    callback: function ($$v) {
                                      _vm.overLinkBillFlagSwitch = $$v
                                    },
                                    expression: "overLinkBillFlagSwitch",
                                  },
                                }),
                                _vm._v(
                                  "\n                （启用后，允许当前单据"
                                ),
                                _c("b", [_vm._v("超出关联单据")]),
                                _vm._v(
                                  "的商品数量进行出入库）\n              "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "更新单价",
                                },
                              },
                              [
                                _c("a-switch", {
                                  attrs: {
                                    "checked-children": "启用",
                                    "un-checked-children": "关闭",
                                  },
                                  on: { change: _vm.onUpdateUnitPriceChange },
                                  model: {
                                    value: _vm.updateUnitPriceFlagSwitch,
                                    callback: function ($$v) {
                                      _vm.updateUnitPriceFlagSwitch = $$v
                                    },
                                    expression: "updateUnitPriceFlagSwitch",
                                  },
                                }),
                                _vm._v(
                                  "\n                （启用后，会根据单据录入自动更新商品单价，默认是启用状态）\n              "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "强审核",
                                },
                              },
                              [
                                _c("a-switch", {
                                  attrs: {
                                    "checked-children": "启用",
                                    "un-checked-children": "关闭",
                                  },
                                  on: { change: _vm.onForceApprovalChange },
                                  model: {
                                    value: _vm.forceApprovalFlagSwitch,
                                    callback: function ($$v) {
                                      _vm.forceApprovalFlagSwitch = $$v
                                    },
                                    expression: "forceApprovalFlagSwitch",
                                  },
                                }),
                                _vm._v("\n                （启用后，只有"),
                                _c("b", [_vm._v("已审核")]),
                                _vm._v(
                                  "的单据才能产生库存，涉及库存查询的相关报表。启用或关闭后需到"
                                ),
                                _c("b", [_vm._v("商品管理")]),
                                _vm._v("批量"),
                                _c("b", [_vm._v("修正库存")]),
                                _vm._v(
                                  "，请按实际业务谨慎操作）\n              "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "出入库管理",
                                },
                              },
                              [
                                _c("a-switch", {
                                  attrs: {
                                    "checked-children": "启用",
                                    "un-checked-children": "关闭",
                                  },
                                  on: { change: _vm.onInOutManageChange },
                                  model: {
                                    value: _vm.inOutManageFlagSwitch,
                                    callback: function ($$v) {
                                      _vm.inOutManageFlagSwitch = $$v
                                    },
                                    expression: "inOutManageFlagSwitch",
                                  },
                                }),
                                _vm._v(
                                  "\n                （启用后，采购销售相关单据都需经过"
                                ),
                                _c("b", [_vm._v("其它出入库")]),
                                _vm._v("单据，才能产生库存。启用或关闭后需到"),
                                _c("b", [_vm._v("商品管理")]),
                                _vm._v("批量"),
                                _c("b", [_vm._v("修正库存")]),
                                _vm._v(
                                  "，请按实际业务谨慎操作）\n              "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "多账户",
                                },
                              },
                              [
                                _c("a-switch", {
                                  attrs: {
                                    "checked-children": "启用",
                                    "un-checked-children": "关闭",
                                  },
                                  on: { change: _vm.onMultiAccountChange },
                                  model: {
                                    value: _vm.multiAccountFlagSwitch,
                                    callback: function ($$v) {
                                      _vm.multiAccountFlagSwitch = $$v
                                    },
                                    expression: "multiAccountFlagSwitch",
                                  },
                                }),
                                _vm._v(
                                  "\n                （启用后，采购订单、采购入库、采购退货、销售订单、销售出库、销售退货等单据的结算账户可以进行多账户选择）\n              "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "移动平均价",
                                },
                              },
                              [
                                _c("a-switch", {
                                  attrs: {
                                    "checked-children": "启用",
                                    "un-checked-children": "关闭",
                                  },
                                  on: { change: _vm.onMoveAvgPriceChange },
                                  model: {
                                    value: _vm.moveAvgPriceFlagSwitch,
                                    callback: function ($$v) {
                                      _vm.moveAvgPriceFlagSwitch = $$v
                                    },
                                    expression: "moveAvgPriceFlagSwitch",
                                  },
                                }),
                                _vm._v(
                                  "\n                （默认为关闭状态，代表成本价等于商品信息页面录入的采购价。开启之后将通过移动平均来计算成本价，需到"
                                ),
                                _c("b", [_vm._v("商品管理")]),
                                _vm._v("批量"),
                                _c("b", [_vm._v("修正成本")]),
                                _vm._v(
                                  "，请按实际业务谨慎操作）\n              "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "先审核后打印",
                                },
                              },
                              [
                                _c("a-switch", {
                                  attrs: {
                                    "checked-children": "启用",
                                    "un-checked-children": "关闭",
                                  },
                                  on: { change: _vm.onAuditPrintChange },
                                  model: {
                                    value: _vm.auditPrintFlagSwitch,
                                    callback: function ($$v) {
                                      _vm.auditPrintFlagSwitch = $$v
                                    },
                                    expression: "auditPrintFlagSwitch",
                                  },
                                }),
                                _vm._v(
                                  "\n                （启用后，零售管理、采购管理、销售管理和仓库管理下的单据，都需要先审核之后才能进行打印）\n              "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "零收付款",
                                },
                              },
                              [
                                _c("a-switch", {
                                  attrs: {
                                    "checked-children": "启用",
                                    "un-checked-children": "关闭",
                                  },
                                  on: { change: _vm.onZeroChangeAmountChange },
                                  model: {
                                    value: _vm.zeroChangeAmountFlagSwitch,
                                    callback: function ($$v) {
                                      _vm.zeroChangeAmountFlagSwitch = $$v
                                    },
                                    expression: "zeroChangeAmountFlagSwitch",
                                  },
                                }),
                                _vm._v(
                                  "\n                （启用后，销售出库单据新建时默认"
                                ),
                                _c("b", [_vm._v("本次收款")]),
                                _vm._v(
                                  "为0，采购入库单据同理）\n              "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "客户静态单价",
                                },
                              },
                              [
                                _c("a-switch", {
                                  attrs: {
                                    "checked-children": "启用",
                                    "un-checked-children": "关闭",
                                  },
                                  on: {
                                    change: _vm.onCustomerStaticPriceChange,
                                  },
                                  model: {
                                    value: _vm.customerStaticPriceFlagSwitch,
                                    callback: function ($$v) {
                                      _vm.customerStaticPriceFlagSwitch = $$v
                                    },
                                    expression: "customerStaticPriceFlagSwitch",
                                  },
                                }),
                                _vm._v(
                                  "\n                （启用后，客户的销售出库的单价不会从该客户历史单据的单价获取，而是只从商品信息获取）\n              "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "商品价格含税",
                                },
                              },
                              [
                                _c("a-switch", {
                                  attrs: {
                                    "checked-children": "启用",
                                    "un-checked-children": "关闭",
                                  },
                                  on: { change: _vm.onMaterialPriceTaxChange },
                                  model: {
                                    value: _vm.materialPriceTaxFlagSwitch,
                                    callback: function ($$v) {
                                      _vm.materialPriceTaxFlagSwitch = $$v
                                    },
                                    expression: "materialPriceTaxFlagSwitch",
                                  },
                                }),
                                _vm._v(
                                  "\n                （启用后，商品中录入的价格变成含税价格，在单据录入中包含了税额）\n              "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "自动打印",
                                },
                              },
                              [
                                _c("a-switch", {
                                  attrs: {
                                    "checked-children": "启用",
                                    "un-checked-children": "关闭",
                                  },
                                  on: { change: _vm.onAutoPrintChange },
                                  model: {
                                    value: _vm.autoPrintFlagSwitch,
                                    callback: function ($$v) {
                                      _vm.autoPrintFlagSwitch = $$v
                                    },
                                    expression: "autoPrintFlagSwitch",
                                  },
                                }),
                                _vm._v(
                                  "\n                （开启后所有单据均自动打印，不能进行报表设计，若要进行报表设计，请在这里关闭）\n              "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "自动凭证",
                                },
                              },
                              [
                                _c("a-switch", {
                                  attrs: {
                                    "checked-children": "启用",
                                    "un-checked-children": "关闭",
                                  },
                                  on: { change: _vm.onAutoVoucherChange },
                                  model: {
                                    value: _vm.autoVoucherFlagSwitch,
                                    callback: function ($$v) {
                                      _vm.autoVoucherFlagSwitch = $$v
                                    },
                                    expression: "autoVoucherFlagSwitch",
                                  },
                                }),
                                _vm._v(
                                  "\n                （开启后业务单据审核通过即自动生成会计凭证；关闭后由财务手工录入/审核）\n              "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "启用系统商品分类",
                                },
                              },
                              [
                                _c("a-switch", {
                                  attrs: {
                                    "checked-children": "启用",
                                    "un-checked-children": "关闭",
                                  },
                                  on: { change: _vm.onEnableCategoryChange },
                                  model: {
                                    value: _vm.enableCategoryFlagSwitch,
                                    callback: function ($$v) {
                                      _vm.enableCategoryFlagSwitch = $$v
                                    },
                                    expression: "enableCategoryFlagSwitch",
                                  },
                                }),
                                _vm._v(
                                  "\n                （启用后，小程序扫码增加商品时自动使用全局商品的系统分类（取前两级），租户没有该分类会自动创建）\n              "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "商城显示商品图片",
                                },
                              },
                              [
                                _c("a-switch", {
                                  attrs: {
                                    "checked-children": "启用",
                                    "un-checked-children": "关闭",
                                  },
                                  on: { change: _vm.onShopImgChange },
                                  model: {
                                    value: _vm.shopImgFlagSwitch,
                                    callback: function ($$v) {
                                      _vm.shopImgFlagSwitch = $$v
                                    },
                                    expression: "shopImgFlagSwitch",
                                  },
                                }),
                                _vm._v(
                                  "\n                （开启后商城（小程序/PC）商品列表显示缩略图，商品无图时显示占位图；关闭后不显示图片）\n              "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "会员商城自动上架",
                                },
                              },
                              [
                                _c("a-switch", {
                                  attrs: {
                                    "checked-children": "启用",
                                    "un-checked-children": "关闭",
                                  },
                                  on: { change: _vm.onMemberAutoShelfChange },
                                  model: {
                                    value: _vm.memberAutoShelfFlagSwitch,
                                    callback: function ($$v) {
                                      _vm.memberAutoShelfFlagSwitch = $$v
                                    },
                                    expression: "memberAutoShelfFlagSwitch",
                                  },
                                }),
                                _vm._v(
                                  "\n                （开启后从未配置过的商品有库存即自动上架到会员商城；手动上架/下架的商品仍以手动配置为准，手动下架的商品有库存也不显示）\n              "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.isShowApproval
                          ? _c(
                              "a-col",
                              { attrs: { lg: 24, md: 24, sm: 24 } },
                              [
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      labelCol: _vm.labelCol,
                                      wrapperCol: _vm.wrapperCol,
                                      label: "多级审核",
                                    },
                                  },
                                  [
                                    _c("a-switch", {
                                      attrs: {
                                        "checked-children": "启用",
                                        "un-checked-children": "关闭",
                                      },
                                      on: {
                                        change: _vm.onMultiLevelApprovalChange,
                                      },
                                      model: {
                                        value: _vm.multiLevelApprovalFlagSwitch,
                                        callback: function ($$v) {
                                          _vm.multiLevelApprovalFlagSwitch = $$v
                                        },
                                        expression:
                                          "multiLevelApprovalFlagSwitch",
                                      },
                                    }),
                                    _c(
                                      "a-select",
                                      {
                                        staticStyle: {
                                          width: "400px",
                                          "padding-left": "10px",
                                        },
                                        attrs: {
                                          placeholder: "请选择流程类型",
                                          mode: "multiple",
                                          maxTagCount: 6,
                                          dropdownMatchSelectWidth: false,
                                          showSearch: "",
                                          "allow-clear": "",
                                          optionFilterProp: "children",
                                        },
                                        on: {
                                          change: _vm.onMultiBillTypeChange,
                                        },
                                        model: {
                                          value: _vm.multiBillTypeSelect,
                                          callback: function ($$v) {
                                            _vm.multiBillTypeSelect = $$v
                                          },
                                          expression: "multiBillTypeSelect",
                                        },
                                      },
                                      _vm._l(
                                        _vm.billTypeList,
                                        function (item, index) {
                                          return _c(
                                            "a-select-option",
                                            {
                                              key: index,
                                              attrs: { value: item.key },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(item.value) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                    _vm._v(
                                      "\n                （启用后，多级审核需配置流程，开启后需刷新浏览器才能看到效果）"
                                    ),
                                    _c(
                                      "a-button",
                                      {
                                        attrs: { type: "link" },
                                        on: { click: _vm.handleReload },
                                      },
                                      [_vm._v("点此刷新")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    ref: "sec3",
                    staticClass: "section",
                    attrs: { id: "sec3" },
                  },
                  [
                    _c("h2", [_vm._v("总店性质")]),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "总店性质",
                                },
                              },
                              [
                                _c("a-switch", {
                                  attrs: {
                                    "checked-children": "启用",
                                    "un-checked-children": "关闭",
                                  },
                                  on: { change: _vm.onHeadquartersChange },
                                  model: {
                                    value: _vm.isHeadquartersSwitch,
                                    callback: function ($$v) {
                                      _vm.isHeadquartersSwitch = $$v
                                    },
                                    expression: "isHeadquartersSwitch",
                                  },
                                }),
                                _vm._v(
                                  "\n                （开启后本租户可作为总店添加门店）\n              "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.isHeadquartersSwitch
                          ? _c(
                              "a-col",
                              { attrs: { lg: 24, md: 24, sm: 24 } },
                              [
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      labelCol: _vm.labelCol,
                                      wrapperCol: _vm.wrapperCol,
                                      label: "允许查询门店的数据项",
                                    },
                                  },
                                  [
                                    _c(
                                      "a-checkbox-group",
                                      {
                                        staticStyle: { "padding-left": "10px" },
                                        on: {
                                          change: _vm.onAllowQueryItemsChange,
                                        },
                                        model: {
                                          value: _vm.allowQueryItemsChecked,
                                          callback: function ($$v) {
                                            _vm.allowQueryItemsChecked = $$v
                                          },
                                          expression: "allowQueryItemsChecked",
                                        },
                                      },
                                      _vm._l(
                                        _vm.queryItemDomainList,
                                        function (item) {
                                          return _c(
                                            "a-checkbox",
                                            {
                                              key: item.value,
                                              attrs: { value: item.value },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(item.label) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                    _vm._v(
                                      "\n                （开启的数据项，总店在报表页可选择门店查询该店数据；未开启不能查）\n              "
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    ref: "sec4",
                    staticClass: "section",
                    attrs: { id: "sec4" },
                  },
                  [
                    _c("h2", [_vm._v("地址定位与地图服务")]),
                    _vm.hqManaged
                      ? _c("div", { staticClass: "hq-managed-tip" }, [
                          _vm._v(
                            "\n            该门店未开启收款，公司信息与地图配置由总店统一维护（当前为只读）\n          "
                          ),
                        ])
                      : _vm._e(),
                    _c(
                      "a-row",
                      { staticClass: "form-row", attrs: { gutter: 24 } },
                      [
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "腾讯地图Key",
                                },
                              },
                              [
                                _c("a-input", {
                                  staticStyle: { width: "400px" },
                                  attrs: {
                                    placeholder: "腾讯位置服务 Key",
                                    disabled: _vm.hqManaged,
                                  },
                                  model: {
                                    value: _vm.geoForm.tencentMapKey,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.geoForm,
                                        "tencentMapKey",
                                        $$v
                                      )
                                    },
                                    expression: "geoForm.tencentMapKey",
                                  },
                                }),
                                _c("div", { staticClass: "profile-tip" }, [
                                  _vm._v(
                                    '需在腾讯位置服务控制台创建 Key 并勾选"JavaScript API"与"Web服务API"两类产品；费用由商户自己承担'
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol,
                                  label: "所在区域",
                                },
                              },
                              [
                                _c("a-cascader", {
                                  staticStyle: { width: "400px" },
                                  attrs: {
                                    options: _vm.areaOptions,
                                    placeholder: "请选择省/市/区",
                                    disabled: _vm.hqManaged,
                                    "change-on-select": "",
                                  },
                                  on: { change: _vm.onGeoAreaChange },
                                  model: {
                                    value: _vm.geoAreaPath,
                                    callback: function ($$v) {
                                      _vm.geoAreaPath = $$v
                                    },
                                    expression: "geoAreaPath",
                                  },
                                }),
                                _c("div", { staticClass: "profile-tip" }, [
                                  _vm._v(
                                    "公司注册地址即门店经营地址（一租户一营业执照）；区域与定位供进件预填、外卖配送距离、小程序门店地图使用"
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: { xs: 24, sm: 20 },
                                  label: "公司地址",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "addr-search-row" },
                                  [
                                    _c("a-input", {
                                      directives: [
                                        {
                                          name: "decorator",
                                          rawName: "v-decorator.trim",
                                          value: ["companyAddress"],
                                          expression: "[ 'companyAddress' ]",
                                          modifiers: { trim: true },
                                        },
                                      ],
                                      staticStyle: { width: "400px" },
                                      attrs: {
                                        placeholder:
                                          "请输入详细地址（无需填写省市区），点搜索定位",
                                        disabled: _vm.hqManaged,
                                      },
                                      on: {
                                        change: _vm.handleCompanyAddress,
                                        pressEnter: _vm.onGeoAddressSearch,
                                      },
                                    }),
                                    _c(
                                      "a-button",
                                      {
                                        staticClass: "addr-search-btn",
                                        attrs: {
                                          type: "primary",
                                          icon: "search",
                                          disabled: _vm.hqManaged,
                                        },
                                        on: { click: _vm.onGeoAddressSearch },
                                      },
                                      [_vm._v("搜索")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { lg: 24, md: 24, sm: 24 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: { xs: 24, sm: 20 },
                                  label: "地图定位",
                                },
                              },
                              [
                                _c("map-location-panel", {
                                  ref: "geoPanel",
                                  attrs: {
                                    lat: _vm.geoForm.lat,
                                    lng: _vm.geoForm.lng,
                                    address: _vm.model.companyAddress,
                                    disabled: _vm.hqManaged,
                                  },
                                  on: { change: _vm.onGeoMapChange },
                                }),
                                _c("div", { staticClass: "profile-tip" }, [
                                  _vm._v(
                                    "地图选点/搜索后详细地址自动回填上方公司地址；改动后点页面右上角「保存」统一生效"
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }